import { Formik, Form, ErrorMessage } from 'formik';
import { useState } from 'react';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useAddPage from 'hooks/useAddPage';
const SavingstransactionAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		accountnumber: yup.string().required().label($t('accountnumber')),
		ledger_balance: yup.string().required().label($t('balance')),
		transaction_type: yup.string().required().label($t('transactionType')),
		transactiondate: yup.string().required().label($t('transactiondate')),
		ac_code: yup.string().required().label($t('acCode')),
		debit: yup.string().required().label($t('debit')),
		credit: yup.string().required().label($t('credit')),
		narration: yup.string().nullable().label($t('narration')),
		branchcode: yup.string().required().label($t('branchcode')),
		empcode: yup.string().required().label($t('empcode')),
		created_by: yup.number().nullable().label($t('createdBy')),
		transactiontime: yup.string().nullable().label($t('transactiontime'))
	});
	
	//form default values
	const formDefaultValues = {
		accountnumber: '', 
		ledger_balance: "0", 
		transaction_type: "DEPOSIT", 
		transactiondate: new Date(), 
		ac_code: '', 
		debit: "0", 
		credit: "0", 
		narration: '', 
		branchcode: '', 
		empcode: '', 
		created_by: auth.userId, 
		transactiontime: new Date(), 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/savingstransaction`);
		}
	}
	
	//auto fill other inputs on accountnumber change
	async function accountnumberAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/savingstransaction_accountnumber_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('branchcode', data.branchcode);
formik.setFieldValue('empcode', data.empcode);
formik.setFieldValue('ledger_balance', data.balance);
		}
	};
  // Photo & Signature Modal state
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [mediaData, setMediaData] = useState({ 
        photo: null, 
        signature: null, 
        account: '',
        photoUrl: null,
        signatureUrl: null
    });
    const [loadingMedia, setLoadingMedia] = useState(false);
    const [loadingAccountData, setLoadingAccountData] = useState(false);
    const handleViewMedia = async (accountnumber) => {
    const acc = accountnumber;
    if (!acc) {
        return;
    }
    setLoadingMedia(true);
    setMediaData({
        photo: null,
        signature: null,
        account: acc,
        photoUrl: null,
        signatureUrl: null
    });
    setShowMediaModal(true);
    try {
        const response = await api.get(
            `SavingsMedia/account/${acc}/images/base64`
        );
        if (response?.data) {
            setMediaData({
                photo: response.data.photoImage || null,
                signature: response.data.signatureImage || null,
                account: response.data.accountNumber || acc,
                photoUrl: response.data.photoImage
                    ? `data:image/jpeg;base64,${response.data.photoImage}`
                    : null,
                signatureUrl: response.data.signatureImage
                    ? `data:image/jpeg;base64,${response.data.signatureImage}`
                    : null
            });
        } else {
            await fetchImagesSeparately(acc);
        }
    } catch (error) {
        console.error(error);
        await fetchImagesSeparately(acc);
    } finally {
        setLoadingMedia(false);
    }
};
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="SavingstransactionAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewSavingsDeposit')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div className="">
                        {/* PHOTO & SIGNATURE MODAL */}
                        {showMediaModal && (
                        <div className="media-overlay" onClick={() => {
                            setShowMediaModal(false);
                            cleanupMediaUrls();
                            }}>
                            <div className="media-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="modal-header">
                                    <h3>
                                    <i className="pi pi-id-card" style={{ color: '#4f46e5' }}></i>
                                    Photo & Signature · {mediaData.account || 'Account'}
                                    </h3>
                                    <Button
                                    icon="pi pi-times"
                                    className="p-button-text p-button-plain"
                                    onClick={() => {
                                    setShowMediaModal(false);
                                    cleanupMediaUrls();
                                    }}
                                    />
                                </div>
                                {loadingMedia ? (
                                <div style={{ textAlign: 'center', padding: '3rem' }}>
                                    <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                                    <p style={{ marginTop: '1rem', color: '#475569' }}>Loading images...</p>
                                </div>
                                ) : (
                                <div className="media-grid">
                                    {/* Photo */}
                                    <div className="media-box">
                                        <div className="media-label">
                                            <i className="pi pi-image" style={{ color: '#3b82f6' }}></i>
                                            Photo
                                            {!mediaData.photo && <span className="status-badge">Not available</span>}
                                        </div>
                                        <div className="media-content">
                                            {mediaData.photo ? (
                                            <img 
                                            src={mediaData.photoUrl || `data:image/jpeg;base64,${mediaData.photo}`} 
                                            alt="Transaction photo" 
                                            />
                                            ) : (
                                            <div className="empty-placeholder">
                                                <i className="pi pi-camera"></i>
                                                <span>No photo attached</span>
                                            </div>
                                            )}
                                        </div>
                                    </div>
                                    {/* Signature */}
                                    <div className="media-box">
                                        <div className="media-label">
                                            <i className="pi pi-pen" style={{ color: '#8b5cf6' }}></i>
                                            Signature
                                            {!mediaData.signature && <span className="status-badge">Not available</span>}
                                        </div>
                                        <div className="media-content">
                                            {mediaData.signature ? (
                                            <img 
                                            src={mediaData.signatureUrl || `data:image/jpeg;base64,${mediaData.signature}`} 
                                            alt="Transaction signature" 
                                            />
                                            ) : (
                                            <div className="empty-placeholder">
                                                <i className="pi pi-pen"></i>
                                                <span>No signature provided</span>
                                            </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                )}
                                <div className="footer-actions">
                                    <Button
                                    label="Close"
                                    icon="pi pi-times"
                                    className="p-button-text"
                                    onClick={() => {
                                    setShowMediaModal(false);
                                    cleanupMediaUrls();
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                        )};
                    </div>
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountnumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/accountnumber_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="accountnumber"     optionLabel="label" optionValue="value" value={formik.values.accountnumber} onChange={(e)=>accountnumberAutoFill(e, formik)} options={response} label={$t('accountnumber')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.accountnumber)}   />
                                                    <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                        <Button
																			type="button"
																			icon="pi pi-image"
																			label="View Media"
																			className="p-button-outlined p-button-sm"
																			onClick={() => handleViewMedia(formik.values.accountnumber)}
																			disabled={!formik.values.accountnumber}
																			loading={loadingMedia}
																			style={{ whiteSpace: 'nowrap' }}
/>

                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('balance')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ledger_balance"  onChange={formik.handleChange}  value={formik.values.ledger_balance}   label={$t('balance')} type="text" placeholder={$t('enterBalance')}     disabled   className={inputClassName(formik?.errors?.ledger_balance)} />
                                                <ErrorMessage name="ledger_balance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactionType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="transaction_type"  onChange={formik.handleChange}  value={formik.values.transaction_type}   label={$t('transactionType')} type="text" placeholder={$t('enterTransactionType')}     disabled   className={inputClassName(formik?.errors?.transaction_type)} />
                                                <ErrorMessage name="transaction_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiondate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiondate" showButtonBar className={inputClassName(formik?.errors?.transactiondate)} dateFormat="yy-mm-dd" value={formik.values.transactiondate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="transactiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acCode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_code_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_code"     optionLabel="label" optionValue="value" value={formik.values.ac_code} onChange={formik.handleChange} options={response} label={$t('acCode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.ac_code)}   />
                                                    <ErrorMessage name="ac_code" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('debit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="debit"  onChange={formik.handleChange}  value={formik.values.debit}   label={$t('debit')} type="text" placeholder={$t('enterDebit')}     disabled   className={inputClassName(formik?.errors?.debit)} />
                                                <ErrorMessage name="debit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('credit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit"  onChange={formik.handleChange}  value={formik.values.credit}   label={$t('credit')} type="text" placeholder={$t('enterCredit')}        className={inputClassName(formik?.errors?.credit)} />
                                                <ErrorMessage name="credit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('narration')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="narration"  onChange={formik.handleChange}  value={formik.values.narration}   label={$t('narration')} type="text" placeholder={$t('enterNarration')}        className={inputClassName(formik?.errors?.narration)} />
                                                <ErrorMessage name="narration" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('createdBy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="created_by"  onChange={formik.handleChange}  value={formik.values.created_by}   label={$t('createdBy')} type="number" placeholder={$t('enterCreatedBy')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.created_by)} />
                                                <ErrorMessage name="created_by" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiontime')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiontime" value={formik.values.transactiontime} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.transactiontime)}     showTime timeOnly     />
                                                <ErrorMessage name="transactiontime" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
SavingstransactionAddPage.defaultProps = {
	primaryKey: 'transactionid',
	pageName: 'savingstransaction',
	apiPath: 'savingstransaction/add',
	routeName: 'savingstransactionadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SavingstransactionAddPage;
